import {useState} from 'react';
import * as ServerComms from '../utilities/ServerComms';
import NormalBtn from '../StockItems/NormalBtn';
import TableWrapRowsBoot from '../StockItems/TableWrapRowsBoot';

function App(props) {

  var width = props.width;
  var clickBack = props.clickBack;

  const [isSubmitted, setIsSubmitted] = useState(0);
  const [elaboration, setEleboration] = useState('');
  const [email, setEmail] = useState("");

    function onElaborate(e){
      setEleboration(e.target.value);
    }
    function onEmail(e){
      setEmail(e.target.value);
    }

    function clickSubmit(e){
      var postFunction = function(responseIn){
        setIsSubmitted(1);
        setEleboration("");
        setEmail("");
      }

      var failFunction = function(){
        console.log("Fail");
      }

      var email1 = email.trim();
      var elaboration1 = elaboration.trim();

      if (email1.length === 0 || elaboration1.length === 0){
        window.alert("Empty fields not allowed");
        return;
      }

      var passObject = {
          u:'submitElab',
          elaboration:elaboration1,
          email:email1,
          selectedTab:-1,
        };
        
     ServerComms.fetchSomething(passObject, postFunction, failFunction, [], 1);             
   }

    function clickOk(e){
      clickBack();
      // setIsSubmitted(0);
    }

  if (isSubmitted === 1){
    return <div>Thank you for your request. We will get back to you via email within 24 hours<br/><br/><NormalBtn onClick={clickOk} title="Ok"/></div>
//
//
  // }else if (userID === -1){
  //   actionBit = <GoogleLogIn setUserIDVPassword={setUserIDVPassword} />
  }
//
  var videos = [{t:'DApps Builder series', l:'https://www.youtube.com/watch?v=jKJ6xszobVo&list=PLAc4K9R1vVPQxZIGDam6X3MLMlbr2sOCT'}, 
  {t:'FAQ series', l:'https://www.youtube.com/watch?v=9Ji7yB0t3So&list=PLAc4K9R1vVPSGQPTZgvj8GQob-egGEZCo'},
  ];


  function clickVid(link){
    return function(e){
      window.open(link);
    }
  }

  function clickAddress(e){
    window.open('https://t.me/+yK9fP_1z27Q2NzVl');
  }

  var topUpRows = videos.map((aVid, index)=>{
    return <tr key={index}><td style={{textDecoration:'underline', cursor:'pointer'}} onClick={clickVid(aVid.l)}>{aVid.t}</td></tr>
  })

    return <div style={{padding:'10px', width}}>
      <TableWrapRowsBoot rows={topUpRows} headerCells={['Tutorial Videos']}/>           

      Please send us any feedback if anything is not working, if you are unsure about something or if you want a new function or element for your dApp.<br/><br/>You may contact us via Telegram @cuessg and we will get back to you as soon as possible. You may also wish to join our community chat via clicking <span onClick={clickAddress} style={{cursor:'pointer'}}><u>here</u></span>. Alternatively, you can use the following form.<br/><br/>
    <input className='inputBoxClassLong' autoFocus value={email} onChange={onEmail} style={{width:"80%"}} placeholder='Email Address so that we can get back to you' /><br/>

    <textarea rows={20} className='inputBoxClassLong' value={elaboration} onChange={onElaborate} style={{width:"80%"}} placeholder='All suggestions on additional contracts, bugs detected, or feedback most welcome!' /><br/>
    <NormalBtn title='Submit' onClick={clickSubmit} /><NormalBtn title='Cancel' onClick={clickOk} />
      </div>

}

export default App;
